<template>
  <v-app-bar app
             color="bars"
             dark
             flat
             tile>

    <v-card color="transparent"
            flat
            tile
            class="d-flex flex-grow-1 pa-0 ma-0">
      <div class="d-flex flex-grow-1 align-center">

        <div class="d-flex flex-grow-1 align-center">

          <v-app-bar-nav-icon @click="drawer = !drawer">
          </v-app-bar-nav-icon>

          <div v-if="drawer === false"
               class="ml-4">
            <v-img src="/v2/images/mobilelocker_logo_white.png"
                   max-height="48"
                   max-width="203"
                   contain/>
          </div>

          <v-spacer></v-spacer>

          <v-icon v-if="isLoading"
                  class="mx-1">
            fal fa-spin fa-spinner
          </v-icon>

          <v-btn text
                 v-if="jobs.length"
                 class="mx-1">
            <v-icon color="success"
                    left>
              fas fa-spin fa-spinner
            </v-icon>
            Processing {{ jobs.length | pluralize('file') }}
          </v-btn>

          <template v-if="team && teams.length > 1">
            <v-btn @click.prevent="openSwitchTeamDialog"
                   dark
                   text
                   class="mx-1">
              <v-icon left>
                fas fa-fw fa-repeat
              </v-icon>
              {{ team.name }}
            </v-btn>
          </template>

          <v-menu tile
                  bottom
                  left
                  offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon
                     v-on="on"
                     v-bind="attrs">
                <v-icon>
                  fas fa-user-circle
                </v-icon>
              </v-btn>
            </template>
            <v-list dense
                    tile
                    flat>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ user.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ user.email }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item :to="{name: `library.edit_profile`}">
                <v-list-item-icon class="mr-2">
                  <v-icon small>
                    fas fa-fw fa-id-badge
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Edit My Profile
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click.prevent="logout">
                <v-list-item-icon class="mr-2">
                  <v-icon small>
                    fas fa-fw fa-sign-out
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Sign Out
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

      </div>
    </v-card>

    <SwitchTeamDialog v-if="switchTeamDialog"
                      :dialog="switchTeamDialog"
                      @close="closeSwitchTeamDialog">
    </SwitchTeamDialog>
  </v-app-bar>
</template>
<script>
import SwitchTeamDialog from '../pages/teams/components/SwitchTeamDialog.vue';
import {mapGetters, mapMutations} from 'vuex';
import {uniqBy} from 'lodash';

export default {
  components: {
    SwitchTeamDialog,
  },
  data() {
    return {
      search: false,
      switchTeamDialog: false,
    }
  },
  computed: {
    ...mapGetters([
      'authenticated',
      'drawer',
      'isLoading',
      'presentationJobs',
      'team',
      'teams',
      'title',
      'user',
    ]),
    drawer: {
      get() {
        return this.$store.state.system.drawer
      },
      set(val) {
        this.$store.commit('setDrawer', val)
      },
    },
    jobs() {
      return uniqBy(this.presentationJobs, 'presentation_id');
    }
  },
  methods: {
    ...mapMutations([
      'setDrawer',
    ]),
    async logout() {
      await this.$store.dispatch('logout');
    },
    openSwitchTeamDialog() {
      this.switchTeamDialog = true;
    },
    closeSwitchTeamDialog() {
      this.switchTeamDialog = false;
    }
  }
}
</script>
